export default function NonAuthScren() {
  return (
    <div>
      <h1>Harnon Marketing Node</h1>
      <p>The best uility for Marketing Visualition</p>
    </div>
  )
}
